/**
 * ATC Click Tracker
 *
 * Tracks "Add to Cart" form submissions from both:
 *   - The main product page button  (form id: BuyButtons-ProductForm-*)
 *   - The sticky bar button         (form id: StickyAtc-ProductForm-*)
 *
 * Each click sends a JSON record to WEBHOOK_URL.
 * Set WEBHOOK_URL to your Google Apps Script endpoint (see setup guide in comments).
 *
 * Log record format:
 * { date, time, button, product_id, product_title, variant_id, quantity, ip, country, state, city, url, user_agent }
 */

const WEBHOOK_URL = window.__ATC_TRACKER_WEBHOOK__ || '';

(function () {
  const tracked = new WeakSet();

  function getTimestamp() {
    const now = new Date();
    return {
      date: now.toISOString().slice(0, 10),
      time: now.toISOString().slice(11, 19) + ' UTC',
    };
  }

  async function getGeoInfo() {
    // Primary: ipinfo.io (50k req/month free, CORS-safe)
    try {
      const res = await fetch('https://ipinfo.io/json', { cache: 'no-store' });
      const json = await res.json();
      if (json.ip) {
        return {
          ip: json.ip,
          country: json.country || 'unknown',  // e.g. "US"
          state: json.region || 'unknown',      // e.g. "Texas"
          city: json.city || 'unknown',
        };
      }
    } catch { /* fall through */ }

    // Fallback: ipify for IP only
    try {
      const res = await fetch('https://api.ipify.org?format=json', { cache: 'no-store' });
      const json = await res.json();
      return { ip: json.ip || 'unknown', country: 'unknown', state: 'unknown', city: 'unknown' };
    } catch {
      return { ip: 'unknown', country: 'unknown', state: 'unknown', city: 'unknown' };
    }
  }

  async function sendLog(payload) {
    if (!WEBHOOK_URL) {
      console.log('[ATC Tracker]', payload);
      return;
    }
    try {
      await fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        mode: 'no-cors',
      });
    } catch (err) {
      console.warn('[ATC Tracker] Failed to send log:', err);
    }
  }

  function attachTracker(form) {
    if (tracked.has(form)) return;
    tracked.add(form);

    const isSticky = form.closest('sticky-atc-bar') !== null;
    const buttonType = isSticky ? 'sticky' : 'main';

    form.addEventListener('submit', async () => {
      const variantInput = form.querySelector('input[name="id"]');
      const quantityInput = form.querySelector('input[name="quantity"]');
      const { date, time } = getTimestamp();
      const geo = await getGeoInfo();

      const payload = {
        date,
        time,
        button: buttonType,
        product_id: form.closest('[data-product-id]')?.dataset?.productId || '',
        product_title: document.title.replace(' – GingerglowGift', '').trim(),
        variant_id: variantInput?.value || '',
        quantity: quantityInput?.value || '1',
        ip: geo.ip,
        country: geo.country,
        state: geo.state,
        city: geo.city,
        url: window.location.href,
        user_agent: navigator.userAgent,
      };

      sendLog(payload);
    });
  }

  function scanForms() {
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(attachTracker);
  }

  function init() {
    scanForms();

    new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches?.('form[data-type="add-to-cart-form"]')) {
            attachTracker(node);
          } else {
            node.querySelectorAll?.('form[data-type="add-to-cart-form"]').forEach(attachTracker);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
